module.exports = __webpack_public_path__ + "img/ESH.0e1b191b.svg";